import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withRouter } from 'react-router-dom';
import { isEmpty, map } from "lodash";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from 'react-moment';
import {
  Row,
  Col,
  FormGroup,
  Label
} from "reactstrap"
import classnames from "classnames"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { withTranslation } from "react-i18next";
import { addFollowNoteTab, getFollowLeadTab, getListLeadTab, addActivityFollowUp, getActivityFollowUp, getContactActivityFollowUp, addContactActivityFollowUp } from "../../../store/actions"
import SaveButton from "components/buttons/save";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import moment from "moment-timezone";
import TimePicker from "components/dropdowns/Timepicker";
import SafeField from "helpers/SafeField";
class FollowLead extends Component {
  constructor(props) {
    super(props)
    this.state = {


    }
    this.handleLeadFollowSubmit = this.handleLeadFollowSubmit.bind(this)
  }
  handleLeadFollowSubmit(value) {
    this.props.addContactActivityFollowUp(value, this.props.history)

  }
  componentDidMount() {
    const { match: { params }, onGetActivityFollowUp } = this.props;
    onGetActivityFollowUp(params.id);
  }
  handleStartTime = (setFieldValue, values) => {
    const { startHrs, startMin, startDif } = values;
    const hours = parseInt(startHrs, 10);
    const minutes = parseInt(startMin, 10);
    const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('startTime', formattedTime);

  };

  handleEndTime = (setFieldValue, values) => {
    const { endHrs, endMin, endDif } = values;
    const hours = parseInt(endHrs, 10);
    const minutes = parseInt(endMin, 10);
    const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('endTime', formattedTime);

  };

  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue('activityLocation', place.formatted_address);
        setFieldValue('activityLatitude', longitude);
        setFieldValue('activityLongitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  render() {
    const { leadFollows, lead, onAddLeadFollowUp, contactDetail } = this.props;
    
    return (
      <React.Fragment>
        {/* <ToastContainer autoClose={2000} /> */}
        <Formik
          enableReinitialize={true}
          initialValues={{
            agentId: parseInt(localStorage.getItem("userId")),
            title: "Call",
            contactname: contactDetail.firstName + " " + contactDetail.lastName,
            contactphone: contactDetail.mobile,
            contactemail: contactDetail.email,
            activityStartDate: new Date(),
            startTime: '',
            endTime: '',
            activityStatus: 1,
            activityType: 3,
            activityRefId: contactDetail.id,
            activityDescription: (this.state && this.state.activityDescription) || "",
            activityLocationType: 3,
            activityLocation: "",
            isActive: true,
            category: 3
          }}
          validationSchema={Yup.object().shape({
            activityDescription: Yup.string().required("This is Required"),
            activityLocation: Yup.string().when('activityType', {
              is: 1,
              then: Yup.string().required("Location is required")
            }),
            startTime: Yup.string().when('activityType', {
              is: (val) => parseInt(val) === 1,
              then: Yup.string().required("Start Time is Required"),
              otherwise: Yup.string().nullable()
            }),

            endTime: Yup.string().when('activityType', {
              is: (val) => parseInt(val) === 1,
              then: Yup.string().required("End Time is Required"),
              otherwise: Yup.string().nullable()
            })
          })}
          onSubmit={(values, { resetForm }) => {
            const formattedValues = {
              ...values,
              activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),

            };

            const result = onAddLeadFollowUp(formattedValues);
            if (result && typeof result.then === "function") {
              result.then(() => resetForm());
            } else {
              resetForm();
            }
          }}
        >
          {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
            <Form className="needs-validation">
              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">

                    <div className="btn-group" role="group">
                      {[
                        { id: 3, label: "Call", title: "Call" },
                        { id: 12, label: "Message", title: "Message" },
                        { id: 4, label: "Email", title: "Email" },
                        { id: 1, label: "Meeting", title: "Meeting" },
                          { id: 2, label: "Task", title: "Task" }
                      ].map(({ id, label, title }) => (

                        <React.Fragment key={id}>
                          <SafeField
                            type="radio"
                            className="btn-check"
                            name="activityType"
                            id={`btnradio-${id}`}
                            value={id}
                            checked={values.activityType === id}
                            onChange={() => {
                              setFieldValue("activityType", id);
                              setFieldValue("title", title);
                            }}
                            autoComplete="off"
                          />
                          <label
                            className="btn btn-outline-secondary"
                            htmlFor={`btnradio-${id}`}
                          >
                            {label}
                          </label>
                        </React.Fragment>
                      ))}
                    </div>
                    <ErrorMessage
                      name="activityType"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="activityDescription">Description*</Label>
                    <SafeField
                      name="activityDescription"
                      as="textarea"
                      className={
                        "form-control" +
                        (errors.activityDescription && touched.activityDescription ? " is-invalid" : "")
                      }
                    />
                    <ErrorMessage
                      name="activityDescription"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="activityStartDate">Date</Label>
                    <Flatpickr
                      className={
                        "form-control" +
                        (errors.activityStartDate && touched.activityStartDate ? " is-invalid" : "")
                      }
                      value={values.activityStartDate}
                      onChange={(date) => setFieldValue('activityStartDate', date[0])}
                      options={{
                        altInput: true,
                        altFormat: "F j, Y",
                        dateFormat: "Y-m-d"
                      }}
                    />
                    <ErrorMessage
                      name="activityStartDate"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

                {values.activityType === 1 && (
                  <>
                    {/* Start Time */}
                    <Col md="6">
                      <TimePicker
                        name="startTime"
                        label="Start Time *"
                        value={values.startTime}
                        onChange={(val) => setFieldValue("startTime", val)}
                        onBlur={() => setFieldTouched("startTime", true)}
                        minTime={null}
                        error={errors.startTime}
                        touched={touched.startTime}
                      />

                      {errors.startTime && touched.startTime && (
                        <div className="invalid-feedback">{errors.startTime}</div>
                      )}

                    </Col>

                    {/* End Time */}
                    <Col md="6">
                      <TimePicker
                        name="endTime"
                        label="End Time *"
                        value={values.endTime}
                        onChange={(val) => setFieldValue("endTime", val)}
                        onBlur={() => setFieldTouched("endTime", true)}
                        minTime={values.startTime}
                        disabled={!values.startTime}
                        error={errors.endTime}
                        touched={touched.endTime}
                      />
                    </Col>

                    {/* Location Type */}
                    <Col md="12">
                      <FormGroup className="mb-3">

                        <div className="btn-group" role="group">
                          <SafeField
                            type="radio"
                            className="btn-check"
                            name="activityLocationType"
                            id="btnradio9"
                            value={3}
                            checked={values.activityLocationType === 3}
                            onChange={() => setFieldValue("activityLocationType", 3)}
                            autoComplete="off"
                          />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio9">
                            In-person
                          </label>

                          <SafeField
                            type="radio"
                            className="btn-check"
                            name="activityLocationType"
                            id="btnradio10"
                            value={1}
                            checked={values.activityLocationType === 1}
                            onChange={() => setFieldValue("activityLocationType", 1)}
                            autoComplete="off"
                          />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio10">
                            Online
                          </label>
                        </div>
                      </FormGroup>
                    </Col>

                    {/* Location */}
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label>Location</Label>
                        {values.activityLocationType === 3 ? (
                          <PlacesAutocomplete
                            value={values.activityLocation}
                            onChange={(value) => setFieldValue('activityLocation', value)}
                            onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                          >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                              <div>
                                <input
                                  {...getInputProps({
                                    placeholder: 'Enter Address...',
                                    className: 'form-control',
                                  })}
                                />
                                <div>
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion, i) => {
                                    const style = {
                                      backgroundColor: suggestion.active ? '#007BFF' : '#fff',
                                      color: suggestion.active ? '#fff' : '#000',
                                      padding: '10px',
                                      cursor: 'pointer'
                                    };
                                    return (
                                      <div
                                        key={i}
                                        {...getSuggestionItemProps(suggestion, { style })}
                                      >
                                        {suggestion.description}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        ) : (
                          <SafeField
                            name="activityLocation"
                            type="text"
                            className={
                              "form-control" +
                              (errors.activityLocation && touched.activityLocation ? " is-invalid" : "")
                            }
                            onChange={handleChange}
                          />
                        )}
                        <ErrorMessage
                          name="activityLocation"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
              </Row>

              <div className="clearfix mt-3">
                <button type="submit" className="btn btn-primary w-md">Save</button>
              </div>
            </Form>
          )}
        </Formik>
        {leadFollows && leadFollows.length > 0 ? (
          <>
            <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
            <ul className="verti-timeline list-unstyled">

              {map(leadFollows, (noteLog, notekey) => (

                <li className="event-list eventlist" key={"_note_" + notekey}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle font-size-18" />
                  </div>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <h5 className="font-size-14">
                        <Moment format="D MMM YY">{noteLog.activityStartDate}</Moment>


                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14"></h5>
                    </div>
                  </div>
                  <div className="exNote">{noteLog.title} : {noteLog.activityDetails}</div>
                </li>
              ))}

            </ul>
          </>
        ) : null}
      </React.Fragment>
    )
  }
}
FollowLead.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  addContactActivityFollowUp: PropTypes.func,
  onGetActivityFollowUp: PropTypes.func,
  leadFollows: PropTypes.array,
  lead: PropTypes.object,
  onAddLeadFollowUp: PropTypes.func,
  contactDetail: PropTypes.object

}

const mapStateToProps = ({ leads, projectleads }) => (
  {
    leadFollows: projectleads.leadFollows,

  })
const mapDispatchToProps = dispatch => ({
  //addContactActivityFollowUp: (data) => dispatch(addContactActivityFollowUp(data)),
  onGetActivityFollowUp: (leadId) => dispatch(getContactActivityFollowUp(leadId)),
  onAddLeadFollowUp: (data) => dispatch(addContactActivityFollowUp(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FollowLead)))
